import {
  TOrderInputType,
} from './pt9800-loading-place';

const orderInputType: Record<TOrderInputType, string> = {
  keyboard: 'Tastatur',
  scanner: 'Scanner',
};

export default {
  orderInputType,
  orderInputlabel: 'Auftragseingabetyp',
  loadingPlace: 'Ladeplatz',
  orderInput: 'Auftrag',
  priority: 'Priorität',
  processFlowNo: 'Prozessablauf-Nr.',
  box: 'Box',
  cellChargeNo: 'Zellencharge-Nr.',
  comment1: 'Kommentar 1',
  comment2: 'Kommentar 2',
  comment3: 'Kommentar 3',
  placeStatus: 'Platzstatus',
  locked: 'gesperrt',
  loadBookedAndReady: 'Charge ist gebucht und bereit',
  enableLoadForAutomatic: 'Charge für Automatik freigeben',
  loadbookingEnded: 'Chargenbuchung beendet',
  camera: 'Kamera',
  noOrderLoaded: 'Kein Auftrag geladen',
};
